<template>
  <el-container class="page">
    <el-header
      class="header"
      style="height:55px"
    >
      <el-popover
        placement="bottom"
        width="500px"
        trigger="click"
      >

        <div
          class="dro_"
          style="display:inline-block"
          slot="reference"
        >
          <img
            class="dro_img"
            src="../assets/touxiang@3x.png"
          />
          <p class="dro_p">
            <span>煜美人</span>
            <span>管理系统</span>
          </p>
        </div>
      </el-popover>

      <a
        class="buy_"
        slot="reference"
      >
        <i class="back-icon-arrowdown"></i>
      </a>
      <el-dropdown
        trigger="click"
        class="user_info"
        style="position: absolute!important"
      >
        <span
          class="el-dropdown-link"
          style="cursor: pointer;"
        >
          {{nickname}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native='showPaa'>修改密码</el-dropdown-item>
          <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <el-container style="min-width:1000px;">
      <el-aside
        class="menu"
        width="210px"
      >

        <el-menu
          router
          :default-active="$store.state.defaultActiveIndex"
          background-color="#282a3c"
          text-color="#e0e0e0"
          active-text-color="#409EFF"
          class="el-menu-vertical-demo"
          @select="handleSelect"
          @open="handleOpen"
          @close="handleClose"
          :collapse="false"
        >
          <el-menu-item v-if="!isArea() index="/">
            <i class="el-icon-setting"></i>
            <span slot="title">控制台</span>
          </el-menu-item>

          <el-menu-item v-if="isArea() index="/AreaDashboard">
            <i class="el-icon-setting"></i>
            <span slot="title">控制台</span>
          </el-menu-item>

          <el-submenu
            index="4"
            v-if="hasPower('10011') || hasPower('10021')"
          >
            <template slot="title">
              <i class="el-icon-location"></i>
              <span slot="title">首页管理</span>
            </template>
            <el-menu-item
              index="/banner_list"
              v-if="hasPower('10011')"
            >
              <span slot="title">轮播图管理</span>
            </el-menu-item>
            <el-menu-item
              index="/hot_word_list"
              v-if="hasPower('10021')"
            >
              <span slot="title">热门搜索列表</span>
            </el-menu-item>
          </el-submenu>

          <!-- <el-submenu
            index="421"
            v-if="hasPower('20011') || hasPower('20041')"
          >
            <template slot="title">
              <i class="el-icon-location"></i>
              <span slot="title">服务订单管理</span>
            </template>
            <el-menu-item
              index="/serviceTypeList"
              v-if="hasPower('20011')"
            >
              <span slot="title">服务类型列表</span>
            </el-menu-item>
            <el-menu-item
              index="/serviceOrderList"
              v-if="hasPower('20041')"
            >
              <span slot="title">订单管理</span>
            </el-menu-item>
          </el-submenu> -->

          <el-submenu
            index="42331"
            v-if="hasPower('20021') || hasPower('20051')"
          >
            <template slot="title">
              <i class="el-icon-location"></i>
              <span slot="title">素材管理</span>
            </template>
            <el-menu-item
              index="/judgeTypeList"
              v-if="hasPower('20051')"
            >
              <span slot="title">素材分类管理</span>
            </el-menu-item>
            <el-menu-item
              index="/judgeList"
              v-if="hasPower('20021')"
            >
              <span slot="title">素材列表</span>
            </el-menu-item>
          </el-submenu>

          <el-submenu
            index="90001"
            v-if="hasPower('90011') || hasPower('90012') || hasPower('90019')"
          >
            <template slot="title">
              <i class="el-icon-location"></i>
              <span slot="title">音视频课程管理</span>
            </template>
            <el-menu-item
              index="/courseTypeList"
              v-if="hasPower('90011')"
            >
              <span slot="title">课程标签管理</span>
            </el-menu-item>
            <el-menu-item
              index="/courseTypeListOO"
              v-if="hasPower('90019')"
            >
              <span slot="title">课程分类管理</span>
            </el-menu-item>
            <el-menu-item
              index="/courseList"
              v-if="hasPower('90012')"
            >
              <span slot="title">课程列表</span>
            </el-menu-item>

            <el-menu-item
              index="/userCardScoreList"
              v-if="hasPower('90013')"
            >
              <span slot="title">打卡积分列表</span>
            </el-menu-item>

            <el-menu-item
              index="/cardMp3List"
              v-if="hasPower('90014')"
            >
              <span slot="title">每日打卡音频</span>
            </el-menu-item>

            <el-menu-item
              index="/backMusicList"
              v-if="hasPower('90015')"
            >
              <span slot="title">背景音乐列表</span>
            </el-menu-item>
            <el-menu-item
              index="/stuCourseList"
              v-if="hasPower('90016')"
            >
              <span slot="title">商学院课程管理</span>
            </el-menu-item>

            <el-menu-item
              index="/stuCourseTypeList"
              v-if="hasPower('90017')"
            >
              <span slot="title">商学院课程类型列表</span>
            </el-menu-item>

            <el-menu-item
              index="/directWatchList"
              v-if="hasPower('90018')"
            >
              <span slot="title">直播列表</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item
            index="/complainList"
            v-if="hasPower('20031')"
          >
            <i class="el-icon-location"></i>
            <span slot="title">投诉管理</span>
          </el-menu-item>

          <!-- <el-menu-item
            index="/send_activity_list"
            v-if="hasPower('80011')"
          >
            <i class="el-icon-location"></i>
            <span slot="title">赠送活动管理</span>
          </el-menu-item> -->

          <el-submenu
            index="3221"
            v-if="hasPower('30081') || hasPower('30011') || hasPower('30082') || hasPower('30021') || hasPower('30031')"
          >
            <template slot="title">
              <i class="el-icon-location"></i>
              <span slot="title">商城管理</span>
            </template>
            <el-menu-item
              index="/goodList"
              v-if="hasPower('30011')"
            >
              <span slot="title">商品管理</span>
            </el-menu-item>

            <el-menu-item
              index="/orderList"
              v-if="hasPower('30021')"
            >
              <span slot="title">订单管理</span>
            </el-menu-item>
            <!-- <el-menu-item
              index="/ac20OrderList"
              v-if="hasPower('30051')"
            >
              <span slot="title">202012月活动订单管理</span>
            </el-menu-item> -->

            <el-menu-item
              index="/stockList"
              v-if="hasPower('30031')"
            >
              <span slot="title">库存管理</span>
            </el-menu-item>

            <el-menu-item
              index="/checkStockList"
              v-if="hasPower('30041')"
            >
              <span slot="title">库存变动审核</span>
            </el-menu-item>

            <el-menu-item
              index="/userTransferHistoryList"
              v-if="hasPower('30081')"
            >
              <span slot="title">换货管理</span>
            </el-menu-item>

            <el-menu-item
              index="/seriesManagement"
              v-if="hasPower('30082')"
            >
              <span slot="title">系列管理</span>
            </el-menu-item>
            <!-- <el-menu-item
              index="/checkOpBu"
              v-if="hasPower('30051')"
            >
              <span slot="title">补货订单审核</span>
            </el-menu-item> -->
            <el-menu-item
              index="/orderListNew"
              v-if="hasPower('30091')"
            >
              <span slot="title">新活动订单管理</span>
            </el-menu-item>

          </el-submenu>

          <el-submenu
            index="3"
            v-if="hasPower('40071') || hasPower('40011') || hasPower('40021') || hasPower('40031') || hasPower('40201')"
          >
            <template slot="title">
              <i class="el-icon-location"></i>
              <span slot="title">用户管理</span>
            </template>
            <el-menu-item
              index="/manager_user_list"
              v-if="hasPower('40011')"
            >
              <span slot="title">员工管理</span>
            </el-menu-item>
            <el-menu-item
              index="/normal_user_list"
              v-if="hasPower('40021')"
            >
              <span slot="title">代理管理</span>
            </el-menu-item>
            <el-menu-item
              index="/up_group_list"
              v-if="hasPower('40031')"
            >
              <span slot="title">代理申请管理</span>
            </el-menu-item>
            <el-menu-item
              index="/storeList"
              v-if="hasPower('40041')"
            >
              <span slot="title">门店管理</span>
            </el-menu-item>
            <el-menu-item
              index="/searchShopList"
              v-if="hasPower('40051')"
            >
              <span slot="title">门店搜索记录</span>
            </el-menu-item>
            <el-menu-item
              index="/districtMaList"
              v-if="hasPower('40091')"
            >
              <span slot="title">区域总监设置</span>
            </el-menu-item>
            <el-menu-item
              index="/districtMaLSet"
              v-if="hasPower('40101')"
            >
              <span slot="title">销售公司设置</span>
            </el-menu-item>

            <el-menu-item
              index="/shopRecordList"
              v-if="hasPower('40071')"
            >
              <span slot="title">店铺修改审核管理</span>
            </el-menu-item>

            <el-menu-item
              index="/areaList"
              v-if="hasPower('40081')"
            >
              <span slot="title">区域管理</span>
            </el-menu-item>
            <el-menu-item
              index="/normal_user_out_black_list"
              v-if="hasPower('40201')"
            >
              <span slot="title">提现黑名单管理</span>
            </el-menu-item>

          </el-submenu>

          <el-submenu
            index="123313"
            v-if="hasPower('51051') || hasPower('50051') || hasPower('50052') || hasPower('50053') || hasPower('50011') || hasPower('50021') || hasPower('50031') || hasPower('50041') || hasPower('50201')"
          >
            <template slot="title">
              <i class="el-icon-location"></i>
              <span slot="title">资金管理</span>
            </template>
            <el-menu-item
              index="/userIntegral"
              v-if="hasPower('50051')"
            >
              <span slot="title">学习积分明细</span>
            </el-menu-item>
            <el-menu-item
              index="/userDeposit"
              v-if="hasPower('50052')"
            >
              <span slot="title">保证金明细</span>
            </el-menu-item>
            <el-menu-item
              index="/userScoreHistory"
              v-if="hasPower('50053')"
            >
              <span slot="title">用户积分明细</span>
            </el-menu-item>
            <el-menu-item
              index="/money_in_list"
              v-if="hasPower('50011')"
            >
              <span slot="title">充值管理</span>
            </el-menu-item>
            <el-menu-item
              index="/money_out_list"
              v-if="hasPower('50021')"
            >
              <span slot="title">一级提现审核</span>
            </el-menu-item>
            <el-menu-item
              index="/money_second_out_list"
              v-if="hasPower('50051')"
            >
              <span slot="title">提现交易记录</span>
            </el-menu-item>
            <el-menu-item
              index="/drGiveM"
              v-if="hasPower('51051')"
            >
              <span slot="title">直接打款</span>
            </el-menu-item>
            <el-menu-item
              index="/money_second_out_black_list"
              v-if="hasPower('50201')"
            >
              <span slot="title">提现黑名单交易记录</span>
            </el-menu-item>
            <!-- <el-menu-item
              index="/change_balance_check"
              v-if="hasPower('50061')"
            >
              <span slot="title">后台修改余额审核</span>
            </el-menu-item> -->
            <el-menu-item
              index="/checkOpDeposit"
              v-if="hasPower('50081')"
            >
              <span slot="title">保证金修改审核</span>
            </el-menu-item>
            <!-- <el-menu-item
              index="/balanceChangeList"
              v-if="hasPower('50031')"
            >
              <span slot="title">余额转账管理</span>
            </el-menu-item> -->
            <!-- <el-menu-item
              index="/redChangeList"
              v-if="hasPower('50041')"
            >
              <span slot="title">红包余额变动列表</span>
            </el-menu-item> -->
            <el-menu-item
              index="/onLinePayList"
              v-if="hasPower('50071')"
            >
              <span slot="title">支付宝微信交易记录</span>
            </el-menu-item>

            <el-menu-item
              index="/directInList"
              v-if="hasPower('50091')"
            >
              <span slot="title">直接进公司金额明细管理</span>
            </el-menu-item>

            <el-menu-item
              index="/waitBuMoneyList"
              v-if="hasPower('50101')"
            >
              <span slot="title">待补货金额明细管理</span>
            </el-menu-item>

            <el-menu-item
              index="/score_out_list"
              v-if="hasPower('50111')"
            >
              <span slot="title">一级小煜提现审核</span>
            </el-menu-item>
            <el-menu-item
              index="/score_second_out_list"
              v-if="hasPower('50121')"
            >
              <span slot="title">二级小煜提现审核</span>
            </el-menu-item>

            <!-- <el-menu-item
              index="/my_score_list"
              v-if="hasPower('50131')"
            >
              <span slot="title">小煜管理</span>
            </el-menu-item> -->

            <el-menu-item
              index="/siPayList"
              v-if="hasPower('50171')"
            >
              <span slot="title">蕊匠交易记录</span>
            </el-menu-item>


            <el-menu-item
              index="/direct_score_list"
              v-if="hasPower('50141')"
            >
              <span slot="title">直属小煜明细</span>
            </el-menu-item>

            <el-menu-item
              index="/plat_record_list"
              v-if="hasPower('50151')"
            >
              <span slot="title">平台户交易明细</span>
            </el-menu-item>
            <el-menu-item
              index="/checkRecordExec"
              v-if="hasPower('50181')"
            >
              <span slot="title">城市加盟商季度考核</span>
            </el-menu-item>
          <!-- <el-menu-item
              index="/giveAreaData"
              v-if="hasPower('50161')"
            >
              <span slot="title">服务商奖金释放设置</span>
            </el-menu-item> -->




          </el-submenu>

          <el-submenu
            index="1233"
            v-if="hasPower('60011') || hasPower('60021') || hasPower('60031') || hasPower('60041') || hasPower('60051') || hasPower('60061') || hasPower('60071') || hasPower('60081') || hasPower('60091') || hasPower('60101s') || hasPower('60111')"
          >
            <template slot="title">
              <i class="el-icon-location"></i>
              <span slot="title">通用管理</span>
            </template>
            <el-menu-item
              index="/goodTypeList"
              v-if="hasPower('60011')"
            >
              <span slot="title">商品分类管理</span>
            </el-menu-item>
            <el-menu-item
              index="/platNoticeList"
              v-if="hasPower('60021')"
            >
              <span slot="title">平台通知管理</span>
            </el-menu-item>

            <el-menu-item
              index="/bankList"
              v-if="hasPower('60031')"
            >
              <span slot="title">银行管理</span>
            </el-menu-item>
            <el-menu-item
              index="/payPosList"
              v-if="hasPower('60121')"
            >
              <span slot="title">收款POS管理</span>
            </el-menu-item>

            <el-menu-item
              index="/dicDataList"
              v-if="hasPower('60041')"
            >
              <span slot="title">字典管理</span>
            </el-menu-item>
            <el-menu-item
              index="/upLogList"
              v-if="hasPower('60051')"
            >
              <span slot="title">升级规则管理</span>
            </el-menu-item>
            <!-- <el-menu-item index="/checkList" v-if="hasPower('60061')">
              <span slot="title">考核设置</span>
            </el-menu-item> -->
            <el-menu-item
              index="/aboutMe"
              v-if="hasPower('60071')"
            >
              <span slot="title">关于我们</span>
            </el-menu-item>
            <!-- <el-menu-item index="/submitRule" v-if="hasPower('60081')">
              <span slot="title">注册协议</span>
            </el-menu-item> -->
            <el-menu-item
              index="/feedBack"
              v-if="hasPower('60091')"
            >
              <span slot="title">意见反馈</span>
            </el-menu-item>
            <el-menu-item
              index="/androidVersion"
              v-if="hasPower('60101')"
            >
              <span slot="title">android版本</span>
            </el-menu-item>
            <el-menu-item
              index="/operationLog"
              v-if="hasPower('60122')"
            >
              <span slot="title">操作日志</span>
            </el-menu-item>

            <el-menu-item
              index="/errorLog"
              v-if="hasPower('60131')"
            >
              <span slot="title">错误日志</span>
            </el-menu-item>

            <!-- <el-menu-item
              index="/scoreRankList"
              v-if="hasPower('60111')"
            >
              <span slot="title">月度返利梯度管理</span>
            </el-menu-item> -->
          </el-submenu>

          <el-submenu
            index="111233"
            v-if="hasPower('70250') || hasPower('70301') || hasPower('70011') || hasPower('70021') || hasPower('70031') || hasPower('70041') || hasPower('70051') || hasPower('70061') || hasPower('70071') || hasPower('70081')  || hasPower('70101') || hasPower('70111') || hasPower('70121') || hasPower('70131')"
          >
            <template slot="title">
              <i class="el-icon-location"></i>
              <span slot="title">统计管理</span>
            </template>

            <el-menu-item
              index="/exportLog"
              v-if="hasPower('70250')"
            >
              <span slot="title">导出任务记录</span>
            </el-menu-item>

            <el-menu-item
              index="/goodPriceDatalist"
              v-if="hasPower('70301')"
            >
              <span slot="title">货物价值统计</span>
            </el-menu-item>
            <el-menu-item
              index="/buOrderListW"
              v-if="hasPower('70141')"
            >
              <span slot="title">补货订单统计</span>
            </el-menu-item>
            <el-menu-item
              index="/buOrderListWHuo"
              v-if="hasPower('70191')"
            >
              <span slot="title">代理活跃度统计</span>
            </el-menu-item>
            <el-menu-item
              index="/area_ac_count"
              v-if="hasPower('70201')"
            >
              <span slot="title">地区活跃度统计</span>
            </el-menu-item>
            <el-menu-item
              index="/saleNumData"
              v-if="hasPower('70011')"
            >
              <span slot="title">商品销量统计</span>
            </el-menu-item>
            <el-menu-item
              index="/saleNumManual"
              v-if="hasPower('70251')"
            >
              <span slot="title">手工操作商品销量统计</span>
            </el-menu-item>
            <el-menu-item
              index="/saleNumExchange"
              v-if="hasPower('70261')"
            >
              <span slot="title">调换货商品销量统计</span>
            </el-menu-item>
            <el-menu-item
              index="/saleNumMarketing"
              v-if="hasPower('70271')"
            >
              <span slot="title">商品销量统计(营销)</span>
            </el-menu-item>
            <el-menu-item
              index="/user_in_data"
              v-if="hasPower('70021')"
            >
              <span slot="title">代理人数新增统计</span>
            </el-menu-item>

            <!-- <el-menu-item
              index="/ceoNumList"
              v-if="hasPower('70021')"
            >
              <span slot="title">CEO省代人数统计</span>
            </el-menu-item> -->

            <el-menu-item
              index="/sendGooData"
              v-if="hasPower('70151')"
            >
              <span slot="title">发货统计</span>
            </el-menu-item>

            <el-menu-item
              index="/dayTonDownFile"
              v-if="hasPower('70161')"
            >
              <span slot="title">通联每日对账文件</span>
            </el-menu-item>



            <el-menu-item
              index="/checkList"
              v-if="hasPower('70031')"
            >
              <span slot="title">考核业绩统计</span>
            </el-menu-item>

            <el-menu-item
              index="/lockUserList"
              v-if="hasPower('70181')"
            >
              <span slot="title">禁用用户记录</span>
            </el-menu-item>
            <el-menu-item
              index="/yearInList"
              v-if="hasPower('70091')"
            >
              <span slot="title">年度考核统计</span>
            </el-menu-item>
            <el-menu-item
              index="/depositData"
              v-if="hasPower('70041')"
            >
              <span slot="title">保证金汇总统计</span>
            </el-menu-item>
            <el-menu-item
              index="/goodOutData"
              v-if="hasPower('70051')"
            >
              <span slot="title">进销存汇总统计</span>
            </el-menu-item>
            <el-menu-item
              index="/fakeSaleData"
              v-if="hasPower('70061')"
            >
              <span slot="title">经销商虚拟库存汇总</span>
            </el-menu-item>
            <el-menu-item
              index="/fakeSaleListData"
              v-if="hasPower('70071')"
            >
              <span slot="title">经销商虚拟库存明细表</span>
            </el-menu-item>
            <el-menu-item
              index="/userInOutData"
              v-if="hasPower('70081')"
            >
              <span slot="title">经销商账户往来款</span>
            </el-menu-item>
            <el-menu-item
              index="/managerMoney"
              v-if="hasPower('70211')"
            >
              <span slot="title">区总奖励查询</span>
            </el-menu-item>

            <el-menu-item
              index="/stockDetail"
              v-if="hasPower('70221')"
            >
              <span slot="title">代理库存明细统计</span>
            </el-menu-item>

            <el-menu-item
              index="/stockDetailAll"
              v-if="hasPower('70231')"
            >
              <span slot="title">代理库存价值统计</span>
            </el-menu-item>

            <el-menu-item
              index="/filialeOrder"
              v-if="hasPower('70291')"
            >
              <span slot="title">分公司订单统计</span>
            </el-menu-item>


            <!-- <el-menu-item
              index="/directScoreTotalData"
              v-if="hasPower('70101')"
            >
              <span slot="title">推荐积分汇总表</span>
            </el-menu-item>

            <el-menu-item
              index="/directScoreTotalDataDetail"
              v-if="hasPower('70121')"
            >
              <span slot="title">推荐积分明细查询表</span>
            </el-menu-item> -->


<!--
            <el-menu-item
              index="/groupScoreTotalData"
              v-if="hasPower('70101')"
            >
              <span slot="title">业绩积分汇总表</span>
            </el-menu-item>

            <el-menu-item
              index="/groupScoreTotalDataDetail"
              v-if="hasPower('70131')"
            >
              <span slot="title">业绩积分明细查询表</span>
            </el-menu-item> -->

          </el-submenu>

          <el-menu-item
            index = "/calculateProfit"
            v-if="hasPower('130001') || hasPower('130002')"
            >
          <i class="el-icon-location"></i>
              <span slot="title">利润统计</span>
          </el-menu-item>


          <el-submenu
            index="110001"
            v-if="hasPower('100002') || hasPower('100001') || hasPower('100003')"
          >
            <template slot="title">
              <i class="el-icon-location"></i>
              <span slot="title">物流端管理</span>
            </template>
            <el-menu-item
              index="/apply"
              v-if="hasPower('100001')"
            >
              <span slot="title">申领管理</span>
            </el-menu-item>
            <el-menu-item
              index="/sendGoodDataGD"
              v-if="hasPower('100004')"
            >
              <span slot="title">广州发货统计</span>
            </el-menu-item>

          </el-submenu>

          <el-menu-item
            index="/activityManagement"
            v-if="hasPower('120002')"
          >
            <i class="el-icon-location"></i>
            <span slot="title">活动管理</span>
          </el-menu-item>

          <!-- <el-menu-item index="/help_list">
            <i class="el-icon-bell"></i>
            <span slot="title">帮助说明管理</span>
          </el-menu-item> -->
        </el-menu>
      </el-aside>

      <!-- <router-view></router-view> -->
      <cp-worktab></cp-worktab>
      <div class="cp-content">
        <keep-alive :exclude="closingPage">
          <router-view></router-view>
        </keep-alive>
      </div>
    </el-container>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogAddVisible"
      width="40%"
    >
      <el-form
        label-position="top"
        class="m-search"
        ref="form"
        size='small'
        :model="form"
        :rules="addFormRule"
      >
        <el-form-item
          label="旧密码"
          prop="old_pass"
        >
          <el-input
            v-model="form.old_pass"
            style="width:70%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="new_pass"
        >
          <el-input
            v-model="form.new_pass"
            style="width:70%"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="addPost()"
            :loading="addLoading"
          >确定</el-button>
          <el-button @click="dialogAddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-container>
</template>
<script>
import Worktab from "./Worktab";
import { bus } from "../bus.js";
import API from "../api/api_user";
var _ = require("lodash");
export default {
  name: "Home",
  created() {
    _.partition([1, 2, 3, 4], n => n % 2);
    this.defaultActiveIndex = this.$route.path;
    bus.$on("setNickName", text => {
      this.nickname = text;
    });

    bus.$on("goto", (url, baseUrl, data) => {
      if (url === "/login") {
        localStorage.removeItem("username");
      }
      if (!baseUrl || baseUrl == null) {
        this.$store.commit("jumpTo", url);
      } else {
        this.$store.commit("jumpTo", baseUrl);
      }
      this.$router.push({ path: url, query: data });
    });
    this.nickname = localStorage.getItem("username");
  },
  data() {
    return {
      powers: [],
      provinceList:[],
      addFormRule: {
        new_pass: [
          { required: true, message: "请输入新密码", trigger: "blur" }
        ],
        old_pass: [{ required: true, message: "请输入旧密码", trigger: "blur" }]
      },
      form: {
        new_pass: null,
        old_pass: null
      },
      dialogAddVisible: false,
      addLoading: false,
      nickname: "刘涛",
      isCollapse: true,
      activeName: "second",
      currentPage1: 5,
      defaultActiveIndex: "/",
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      keywords: "",
      value4: "",
      value2: ""
    };
  },
  components: {
    cpWorktab: Worktab
  },
  computed: {
    closingPage() {
      var list = (this.$store.state.closingPage);
      for(var i=0;i<this.$store.state.realClose.length;i++){
        list.push(this.$store.state.realClose[i])
      }
      return list;
    }
  },
  mounted() {
    this.$store.commit("jumpTo", this.$route.path);
    let user = localStorage.getItem("access-user");
    let powers = localStorage.getItem("powers");
    this.powers = JSON.parse(powers);
    this.provinceList = localStorage.getItem("provinceList");
  },
  methods: {
    isArea(){
      var has = false;
      if (provinceList && provinceList != null && provinceList != '')
      {
        has = true;
      }
      return has;
    },
    hasPower(power) {
      var has = false;
      for (var i = 0; i < this.powers.length; i++) {
        if (this.powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    addPost() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          that.addLoading = true;
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          API.edit_pass(para)
            .then(
              function(result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "修改成功",
                    duration: 1500
                  });
                  that.dialogAddVisible = false;
                  that.addLoading = false;
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.dialogAddVisible = false;
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.dialogAddVisible = false;
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },

    showPaa() {
      this.dialogAddVisible = true;
    },
    handleSelect(index) {
      this.defaultActiveIndex = index;
      this.$store.commit("jumpTo", index);
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    logout() {
      let that = this;
      that
        .$confirm("确认退出吗", "提示", {
          confirmButtonClass: "el-button--warning"
        })
        .then(() => {
          //确认
          that.loading = true;
          let logoutParams = {
            token: localStorage.getItem("api_token")
          };
          API.logout(logoutParams)
            .then(
              function(result) {
                that.loading = false;
                localStorage.removeItem("access-user");
                localStorage.removeItem("username");
                localStorage.removeItem('provinceList')
                localStorage.removeItem("api_token");
                that.$router.go("/login"); //用go刷新
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.page {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  overflow: hidden;
}
.header {
  position: relative;
  width: 100%;
  background: #fafafa;
  box-sizing: border-box;
  border-bottom: solid 1px #eee;
}
.dro_ {
  padding-top: 10px;
}
.dro_img {
  display: inline-block;
  width: 35px;
  height: 35px;
  vertical-align: middle;
}
.dro_p {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  margin-left: 10px;
  max-height: 40px;
  max-width: 250px;
  line-height: 20px;
  cursor: pointer;
}
.dro_p :nth-child(2) {
  vertical-align: middle;
  margin-left: 5px;
  color: #fff;
  background-color: #cdcdcd;
  display: inline-block;
  padding: 0 4px;
  height: 16px;
  line-height: 16px;
  border-radius: 8px;
  font-size: 12px;
}
.el-submenu .el-menu-item::before {
  content: "";
  width: 1px;
  height: 100%;
  background-color: #fff;
  opacity: 0.3;
  position: absolute;
  left: 48px;
  top: 0;
}
.el-submenu .el-menu-item span {
  text-indent: 25px;
  display: inline-block;
}
.el-submenu .el-menu-item::after {
  content: "";
  width: 7px;
  height: 7px;
  box-sizing: border-box;
  border-radius: 100%;
  border: solid 1px #fff;
  position: absolute;
  left: 48px;
  margin-left: -3px;
  top: 50%;
  margin-top: -3px;
}
.dro_p :nth-child(2)::after {
  content: "";
  position: absolute;
  left: 100%;
  top: 50%;
  margin-top: -3px;
  margin-left: 2px;
  border-top: 5px solid #ddd;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  transition: transform 0.2s linear;
}
.buy_ {
  display: inline-block;
  cursor: pointer;
  font-weight: 400;
  border-radius: 2px;
  line-height: 20px;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  color: #fff;
  background-color: #409eff;
  border: 1px solid #409eff;
  padding: 7px 15px 7px;
  margin-left: 20px;
}
.check_school {
  margin: -12px;
}
.check_school li {
  cursor: pointer;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  padding: 7px 15px 7px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.check_school li:first-child {
  border-bottom: 1px #f2f2f2 solid;
}
.chose_sch {
  color: #fff;
  background-color: #409eff;
}
.buy_:hover {
  background-color: #71b3f7;
  border: 1px solid #71b3f7;
}
.user_info {
  position: absolute !important;
  top: 17.5px;
  right: 20px;
}
.u-scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.menu {
  position: absolute;
  overflow-y: scroll;
  overflow-x: hidden;
  left: 0;
  top: 55px;
  bottom: 0;
  width: 205px;
  background-color: #282a3c;
}

.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 20px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  /* height: 200px; */
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}
.aside_sub {
  position: absolute;
  bottom: 30px;
  border-top: 1px solid #364756;
  width: 100%;
}
.aside_sub a {
  display: table;
  margin: 20px auto 10px auto;
  cursor: pointer;
}
.aside_sub span {
  display: table;
  margin: 0 auto;
  font-size: 0.75rem;
  color: #24303c;
  text-align: center;
  width: 100px;
  height: 18px;
  line-height: 18px;
  margin: 0 auto 15px;
  background: #49545e;
  background-image: -moz-linear-gradient(
    0deg,
    #2f3e4d 5%,
    #7d8289 53%,
    #2f3e4d 95%
  );
  background-image: -webkit-linear-gradient(
    0deg,
    #2f3e4d 5%,
    #7d8289 53%,
    #2f3e4d 95%
  );
  background-image: -ms-linear;
}

.cont_navs_header {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  padding-left: 20px;
  display: flex;
  align-items: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 100%;
  display: block;
}
.el-message-box .el-button + .el-button {
  margin-left: 10px !important;
}
.el-tooltip__popper {

  max-width: 800px;
  font-size: 16px !important;
  line-height:26px !important;
  background-color: #409eff !important;
  color: #fff !important;

}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue